import { useEffect } from "react";
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-buttons/js/dataTables.buttons.js";
import "datatables.net-buttons/js/buttons.colVis.js";
import "datatables.net-buttons/js/buttons.html5.js"; // Required for Excel export
import "datatables.net-buttons/js/buttons.print.js";
import "datatables.net-buttons-dt/css/buttons.dataTables.min.css";
import $ from "jquery";
import { Link } from "react-router-dom";
import { BaseUrl } from "../helper/BaseUrl";

// import JSZip from "jszip";
// window.JSZip = JSZip;

const formatDate = (isoString) => {
  const date = new Date(isoString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

const formatValue = (body, value) => {
  // if (!value) return "N/A"; // Handle empty values globally
if (value === undefined || value === null || value === "") return "-";

  const formattedFields = {
    createdAt: formatDate(value), // Format createdAt
    date: formatDate(value), // Format updatedAt if needed
    cover_note: <a target="_blank" href={BaseUrl + value} className="btn btn-success">View</a>, // Format updatedAt if needed
    resume: <a target="_blank" href={BaseUrl + value} className="btn btn-success">View</a>, // Format updatedAt if needed
   linkedin:
  typeof value === "string" && value.includes("https://")
    ? <a target="_blank" href={value} className="btn btn-success">Visit Profile</a>
    : "—",
 // Format updatedAt if needed
    source_url: <a href={value} target="_blank" rel="noreferrer">{value}</a>, // Render as a link
    status: <span className={value === "1" ? "status-btn-inactive" : "status-btn-active"}>{value === "1" ? "Disabled" : "Enabled"}</span>,
      comment: value || "—",
      application_status: (
      <span className={
        value === 1 || value === "1" ? "badge bg-success" :
        value === 0 || value === "0" ? "badge bg-primary" : 
        value === 2 || value === "2" ? "badge bg-danger": 
        value === 3 || value === "3" ? "badge bg-secondary": ""
      }>
        {value === 1 || value === "1" ? "Approved" :
         value === 0 || value === "0" ? "Pending" :
         value === 2 || value === "2" ? "Rejected" : 
        value === 3 || value === "3" ? "In Progress" :"-"}
      </span>
    ),
  };

  return formattedFields[body] || value; // Return formatted value or default
};

export default function DataTable({ data, tableHeader, tbody, editPath, onDelete, showAction = true, setModalShow, setId, tableId = "example3" }) {

  useEffect(() => {
    const tableSelector = `#${tableId}`;
    let timeoutId;

    if ($.fn.DataTable.isDataTable(tableSelector)) {
      $(tableSelector).DataTable().destroy();
    }
    $("#datatable-search").empty();
    $("#datatable-buttons").empty();

    const initializeDataTable = () => {
      const table = $(tableSelector).DataTable({
        destroy: true,
        paging: false,
        pagingType: "full_numbers",
        pageLength: 10,
        processing: true,
        dom: "Bfrtip",
        buttons: ["copy", "csv", "excel", "print"],
        initComplete: function () {
          $(".dt-search input").attr("placeholder", "Search Here");
        },
        drawCallback: function () {
          // Move .dt-search outside (v2 search wrapper)
          if ($(".dt-search").parent().attr("id") !== "datatable-search") {
            $(".dt-search").appendTo("#datatable-search");
          }
        }
      });

      // Move buttons outside
      table.buttons().container().appendTo("#datatable-buttons");

      // Initial move of search
      $(".dt-search").appendTo("#datatable-search");
    };

    if (data && data.length > 0 && $(tableSelector).length) {
      timeoutId = setTimeout(initializeDataTable, 0);
    }

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
      if ($.fn.DataTable.isDataTable(tableSelector)) {
        $(tableSelector).DataTable().destroy();
      }
      $("#datatable-search").empty();
      $("#datatable-buttons").empty();
    };
  }, [data, tableHeader, tbody, tableId]);

  return (
    <>
      <div className="datatable-control">
        <div id="datatable-search"></div>
        <div id="datatable-buttons"></div>
      </div>

      <div className="table-responsive">
        <table id={tableId} className="my-data-table">
          <thead>
            <tr>
              {/* head one static last static (middels are dynamic) */}
              <th>S.No</th>
              {tableHeader.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
              {showAction && <th>Action</th>}
            </tr>
          </thead>


            <tbody>
            {data?.map((item, rowIndex) => (
              <tr key={item._id || rowIndex}>
                <td>{rowIndex + 1}</td>
                {tbody && tbody.map((body, colIndex) => (
                  <td key={colIndex}>{formatValue(body, item[body])}</td>
                ))}
                {showAction && (
                  <td>
                    <div className="table-btn-group">
                      {editPath ?
                        (<Link to={`/${editPath}/${item._id}`} className="edit-btn"><img src="/assets/admin-edit.webp" alt="edit" className="img-responsive" /></Link>
                        ) : (
                          <Link onClick={() => { setModalShow(true); setId(item._id) }} className="edit-btn"><img src="/assets/admin-edit.webp" alt="edit" className="img-responsive" /></Link>
                        )}

                      {onDelete && <Link className="delete-btn" onClick={() => onDelete(item._id)}><img src="/assets/admin-delete.webp" alt="delete" className="img-responsive" /></Link>}
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody> 
{/* 
           <tbody>
            {data?.map((item, rowIndex) => (
              <tr key={rowIndex}>
                <td>{rowIndex+1}</td>
                {tbody.map((body, colIndex) => <td key={colIndex}>{formatValue(body, item[body])}</td>)}
                {showAction && (
                  <td>
                    <div className="table-btn-group">
                      <Link onClick={() => { setModalShow(true); setId(item._id) }} className="edit-btn">
                        <img src="/assets/admin-edit.webp" alt="edit" className="img-responsive" />
                      </Link>
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody> */}
        </table>
      </div>
    </>
  );
}
